module.exports = __webpack_public_path__ + "img/add-1.74c436c1.svg";